import { BogoBannerLocation } from '../../../types/bogoBanner'
import { LOCATION_CHECKOUT, LOCATION_PLANS } from './constants'

type Options = {
  location: BogoBannerLocation
}

export const shouldShowCta = ({ location }: Options) =>
  location !== LOCATION_PLANS && location !== LOCATION_CHECKOUT
